import SliderAbstract from './SliderAbstract.js';

const $ = jQuery;

export default class SliderFeature extends SliderAbstract {
    constructor(selector) {
        super(selector);
    }

    _init() {
        this.featureSlider = null;
        this.isMobile = false;
        this.activeDesktopSlider = 1;
        this.initializedDesktopOnce = false;

        this.settings = Object.assign({}, this.originalSettings);
        this.settings.loop = false;
        this.settings.onClick = function(swiper, event) {
            var $target = $(event.target);
            if (event.clientX < $target.width()/2) {
                swiper.slidePrev();
            } else {
                swiper.slideNext();
            }
        };

        this._initSlider();
        this._addEventListener();
    }

    _initSlider() {
        if (this._isMobileView()) {
            this._initSliderMobile();
        } else {
            this._initSliderDesktop();
        }
    }

    _initSliderMobile() {
        this.isMobile = true;
        $('.swiper__container--ptfeature').show();
        this.featureSlider = new Swiper ('.swiper__container--ptfeature',  this.settings);
    }

    _initSliderDesktop() {
        this.isMobile = false;
        $('.swiper__container--ptfeature').hide();
        $('#feature-swiper-' + this.activeDesktopSlider).find('.swiper__container--ptfeature').show();
        let activeSlider = $('#feature-swiper-' + this.activeDesktopSlider).find('.swiper__container--ptfeature')[0];
        this.featureSlider = new Swiper (activeSlider,  this.settings);
        $('#swiper__menu').find('.swiper__bullet[data-swiper=' + this.activeDesktopSlider + ']').addClass('swiper__bullet--active');

        if (!this.initializedDesktopOnce) {
            this.initializedDesktopOnce = true;

            $('#swiper__menu').find('.swiper__bullet').on('click', (e) => {
                this.activeDesktopSlider = $(e.currentTarget).data('swiper');
                $('#swiper__menu').find('.swiper__bullet').removeClass('swiper__bullet--active');
                this._destroySlider();
                this._initSliderDesktop();
            });
        }
    }

    _addEventListener() {
        $(window).on('resize', () => { this._resizeCallback(); });
    }

    _resizeCallback() {
        if (this._isMobileView() && !this.isMobile) {
            this._destroySlider();
            this._initSliderMobile();
        } else if (!this._isMobileView() && this.isMobile) {
            this._destroySlider();
            this._initSliderDesktop();
        }
    }

    _destroySlider() {
        if (!this.featureSlider) {
            return;
        }

        if (this.featureSlider.length > 1) {
            this.featureSlider.forEach((swiper) => {
                swiper.destroy(true, true);
            });
        } else {
            this.featureSlider.destroy(true,true);
        }
        this.isMobile = false;
    }
}



// WEBPACK FOOTER //
// ./app/themes/template/res/js/src/SliderFeature.js